export enum LogModelEnum {
  ITEM = 'SessionScenarioItem',
  LOG = 'SessionIncidentComment',
}
